export default {
  LEFT_NAV_COLLAPSED: 'LEFT_NAV_COLLAPSED',
  LEFT_NAV_EXPANDED: 'expanded',
  DEVICE_XS: 'xs',
  DEVICE_SM: 'sm',
  DEVICE_MD: 'md',
  DEVICE_LG: 'lg'
};
